import React from 'react';
import Layout from '../components/shared/layout';
import InnerPageBanner from '../components/shared/innerPageBanner';
import ImageIcons from '../components/imageComponent/ImageIcons';
import SEO from '../components/shared/seo';

const VoipIntercom = () => {
  return (
    <>
      <SEO title='Our VoIP Intercom System at My Internet Services' description='Get MyInternet VoIP Intercom System for the future of internet services. Learn about our commitment to innovation, reliability, and customer satisfaction.' />
      <Layout>
        <InnerPageBanner title='VoIP Intercom' innerPageBanner={ImageIcons.voipIntercomBg} />
         
        <section className='relative'>
          <div className='absolute w-[200px] left-[20px] top-[100px] max-lg:hidden animate-[animate-bounceTop_5s_infinite_ease-in-out_alternate] max-lg:opacity-50'>
            <img  className='object-cover rotate-180' src={ImageIcons.aboutShape} alt='Shape' />
          </div>
          <div className='container '>
            <div className='flex lg:flex-nowrap max-lg:flex-col-reverse flex-wrap lg:gap-[50px] gap-[30px] items-center'>
              <div className='lg:w-[50%] w-full lg:py-[50px] md:py-[40px] !py-0 relative ' >
                <div className='relative z-10'>
                  <h2 className='font-bold'><span className='text-[#f38432]'>VoIP Intercom</span> System</h2>
                  <p>A VoIP intercom system uses Voice over Internet Protocol (VoIP) technology to enable voice communication between devices, like phones or intercom stations, over an IP network, such as the internet, instead of traditional phone lines. It essentially allows you to make calls within a building, or across a network, using your internet connection rather than a regular phone line.</p>
                </div>
              </div>
              <div className='lg:w-[50%]'>
                <img  className='object-contain h-full w-full rounded-[20px]' src={ImageIcons.voipIntercom} alt='VoIP Intercom' />
              </div>
            </div>
          </div>
        </section>

      </Layout>
    </>
  )
}

export default VoipIntercom